module.exports = __webpack_public_path__ + "static/bensadouk-mourad-a301944979786cbc4034ad4a1652c52d.jpg";